export default  {
   'apiurl':"https://api.gs.polcode.dev",
   'release': "dev"
};
